import { render } from "./FrontBookView.vue?vue&type=template&id=25019fb0"
import script from "./FrontBookView.vue?vue&type=script&lang=js"
export * from "./FrontBookView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__